import React, {FC, ReactNode} from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Dialog, DialogProps} from 'wix-ui-tpa/cssVars'

import {classes} from './styles.st.css'

type ModalProps = {
  children: ReactNode
} & DialogProps

export const Modal: FC<ModalProps> = ({children, ...props}) => {
  const {t} = useTranslation()

  return (
    <Dialog
      {...props}
      closeButtonAriaLabel={
        props.closeButtonAriaLabel ?? t('uou-reservations.shared.modal-close-button')
      }
      childrenWrapperClassName={classes.contentWrapper}
      wiredToSiteColors={false}
    >
      <div className={classes.content}>{children}</div>
    </Dialog>
  )
}
